(function ($) {

	$(".link-title-item").hover(
		function () {
			$('.link-img, .link-title-item').removeClass('active');
			let linkID = $(this).attr('data-id');
			$('.link-img[data-id=' + linkID + '], .link-title-item[data-id=' + linkID + ']').addClass('active');
		}, function () {

		}
	);

})(jQuery);
